import React, {useMemo} from "react";
import {StartActionType} from "../index";
import {Link, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {matchPath} from "react-router";
import {SearchOutlined, SearchRounded} from "@mui/icons-material";
import {Breakpoint, Theme, useMediaQuery} from "@mui/material";
import useAccessLevels from "../../../../hooks/use-access-levels";
import {useTranslation} from "react-i18next";


const buttonBreakpoint = 'xl';

const useLookupStartAction = (breakpoint: Breakpoint | number): StartActionType | null => {
    const location = useLocation();
    const match = useMemo(() => {
        return matchPath(location.pathname, [
            routes.lookup.search,
            routes.lookup.productInformation,
        ]) && location.pathname !== routes.landing;
    }, [location.pathname])
    const iconButton = useMediaQuery<Theme>((theme) => theme.breakpoints.between(breakpoint, buttonBreakpoint));
    const operatorAccessLevels = useAccessLevels();
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.app-bar.actions.start-action-buttons'});

    return useMemo<(StartActionType | null)>(() =>
        !operatorAccessLevels.packages.lookup.nexusSearch
            ? null
            : ({
                key: 'lookup',
                title: t(t => t.lookup),
                color: "primary" as const,
                icon: match ? <SearchRounded/> : <SearchOutlined/>,
                sx: {
                    '&:hover, &:focus': {
                        color: match ? 'primary.contrastText' : 'primary.main',
                        backgroundColor: match ? 'primary.main' : 'transparent',
                    },
                    ...(iconButton && {
                        backgroundColor: match ? 'primary.main' : 'background.paper',
                        color: match ? 'primary.contrastText' : 'primary.main',
                        '&:hover, &:focus': {
                            color: match ? 'primary.contrastText' : 'primary.main',
                            backgroundColor: match ? 'primary.main' : theme => `rgba(${theme.palette.primary.mainChannel} / ${theme.palette.action.hoverOpacity})`,
                        },
                    })
                },
                component: Link as any,
                to: routes.lookup.search,
                breakpoint: breakpoint,
                buttonBreakpoint: buttonBreakpoint,
                variant: match ? 'contained' : 'outlined',
            }), [operatorAccessLevels.packages.lookup.nexusSearch, t, match, iconButton, breakpoint])
}

export default useLookupStartAction;
